import React from "react";
import { NavLink } from "react-router-dom";
import BrandLogo from "./BrandLogo";

export default function SideNav({ navItems = [] }) {
  return (
    <aside className="sticky top-2 hidden h-[calc(100vh-1rem)] w-72 shrink-0 rounded-[28px] border border-white/70 bg-gradient-to-b from-brand-800 via-brand-700 to-brand-900 p-4 text-white shadow-brand md:flex md:flex-col">
      <div className="rounded-3xl bg-white/10 p-3 backdrop-blur">
        <BrandLogo />
      </div>

      <div className="mt-6 space-y-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                [
                  "flex items-center gap-3 rounded-2xl px-4 py-3 text-sm font-bold transition",
                  isActive ? "bg-white text-brand-800 shadow-lg" : "bg-white/5 text-white hover:bg-white/10"
                ].join(" ")
              }
            >
              <Icon className="h-5 w-5" />
              <span>{item.label}</span>
            </NavLink>
          );
        })}
      </div>

      <div className="mt-auto rounded-2xl border border-white/10 bg-white/5 p-3 text-xs leading-6 text-white/70">
        <p>© 2026  جميع الحقوق محفوظة.</p>
      </div>
    </aside>
  );
}
